module.exports = __webpack_public_path__ + "static/media/ecopies-home.24376620.png";